import { NFSStatus } from "./nfsUtils";

/**
 * True when the version still has the object as projected while DEFAULT has moved it on to any
 * other status. The version is then outdated, and syncing it would push the old projected state
 * to FDV — which per customer and FDV rules must never happen to e.g. an operative object.
 * Objects that don't exist in DEFAULT (new objects) are never blocked.
 */
export const isInvalidFDVSync = (
    versionStatus: number | null | undefined,
    defaultStatus: number | null | undefined
): boolean =>
    versionStatus === NFSStatus.PROJECTED &&
    defaultStatus !== null &&
    defaultStatus !== undefined &&
    defaultStatus !== NFSStatus.PROJECTED;
